import styled from "@emotion/styled";
import type { FC } from "react";

export type RemoveLiquidityPercentageTagProps = {
  percentage: number;
  className?: string;
  onClick?: (percentage: number) => void;
};

export const RemoveLiquidityPercentageTag: FC<RemoveLiquidityPercentageTagProps> = ({
  percentage,
  className,
  onClick,
}) => (
  <RemoveLiquidityPercentageTagContainer className={className} onClick={() => onClick?.(percentage)}>
    <span>{percentage}%</span>
  </RemoveLiquidityPercentageTagContainer>
);

const RemoveLiquidityPercentageTagContainer = styled.div`
  display: inline-block;
  background: #282828;
  border: 1px solid #434343;
  box-sizing: border-box;
  border-radius: 2px;
  padding: 1px 10px;
  text-align: center;
  cursor: pointer;
  user-select: none;

  span {
    font-weight: bold;
    font-size: 10px;
    line-height: 20px;
  }
`;
